// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
var _ = require('lodash');
import { connect } from 'react-redux';
// import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import GoogleMapReact from 'google-map-react';
import LocationIcon from 'grommet/components/icons/base/Location';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { browserHistory as history } from 'react-router';
import { updateSiteAction, addSiteAction, clearTwigsList } from '../../actions/actions';
import { navEnable } from '../../actions/nav';
import { getMapCenter } from '../../utils/Utility';
import constants from '../../Constants';
import MapOverlay from './MapOverlay';
import Button from 'grommet/components/Button';

var mapComponent;
class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.closeOverlay = this.closeOverlay.bind(this);
    this.mapClick = this.mapClick.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.mapLoaded = this.mapLoaded.bind(this);
    this.addSite = this.addSite.bind(this);
    this.updateSite = this.updateSite.bind(this);
    this.updateSiteLocation = this.updateSiteLocation.bind(this);
    this.markerClick = this.markerClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.placesHandleSelect = this.placesHandleSelect.bind(this);
    this.onSiteNameChange = this.onSiteNameChange.bind(this);
    this.state = {
      center: { lat: 37.09024, lng: -95.712891 },
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0,
      markersArr: [],
      showModalOverlay: false,
      address: '',
      zoom: 12,
      siteName: ''
    }
  }
  componentWillMount() {
    this.props.dispatch(navEnable(true));
    // this.getCenter(this.props.userProfile);
  }


  componentDidMount() {


  }
  componentDidUpdate() {


  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.userProfile && nextProps.userProfile.siteLocation) {
      this.getCenter(nextProps.userProfile);
    }
    let sitesLocation = 0;

    if (nextProps.sites && nextProps.sites.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      let firstItem = '';
      nextProps.sites
        .filter(site => site != undefined && site.location !== undefined)
        .forEach(site => {
          sitesLocation++;
          firstItem = site.location;
          bounds.extend(new google.maps.LatLng(site.location.latitude, site.location.longitude));
        });
      if (sitesLocation == 0) {
        this.getCenter(this.props.userProfile);
      }
      if (sitesLocation == 1) {
        this.setState({
          center: { lat: firstItem.latitude, lng: firstItem.longitude },
          zoom: 15
        })
      } else if (mapComponent) {
        mapComponent.map.fitBounds(bounds);
        mapComponent.maps.event.addListenerOnce(mapComponent.map, 'idle', function () {
          let currentZoomLevel = mapComponent.map.getZoom();
          mapComponent.map.setZoom(currentZoomLevel - 1)
        });
      }
    }

  }

  componentWillUnmount() {
    mapComponent = '';
  }

  getCenter(userProfile) {

    if (userProfile && userProfile.siteLocation) {
      // console.log('setting location from userProfile.siteLocation : '+ userProfile.siteLocation);
      this.setState({
        center: {
          lat: userProfile.siteLocation.latitude, lng: userProfile.siteLocation.longitude
        }
      });
    } else if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition((position) => {

        let postionObj = {
          lat: position.coords.latitude, lng: position.coords.longitude
        }
        // console.log('postionObj::-', postionObj)
        this.setState({
          center: postionObj
        });
      }, (error) => {
        //set US location if browser location not available
        // console.log('cant get navigator.geolocation, using US location.');
        this.setState({
          center: {
            lat: 37.09024, lng: -95.712891
          },
          zoom: 5
        });
      });


    } else {

      //set US location
      this.setState({
        center: {
          lat: 37.09024, lng: -95.712891
        },
        zoom: 5
      });
    }
  }
  mapClick(e) {
    this.setState({
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0
    })
  }
  mapLoaded(mapObj) {
    mapComponent = mapObj;
    mapObj.map.addListener('rightclick', (event) => {

      this.setState({
        showContextMenu: true,
        contextMenTopPos: event.pixel.y,
        contextMenuLeftPos: event.pixel.x,
        markerLat: event.latLng.lat(),
        markerLong: event.latLng.lng()
      })
    });

  }

  addSite(obj) {
    this.setState({
      showContextMenu: false,
      showModalOverlay: true,
      updateSite: false,
      siteName: ''
    });
  }

  updateSite(obj) {
    this.setState({
      showContextMenu: false,
      showModalOverlay: true,
      updateSite: true,
    })
  }

  updateSiteLocation(siteInfo) {
    this.closeOverlay();
    let data = {
      location: {
        latitude: this.state.markerLat,
        longitude: this.state.markerLong
      }
    }
    if (this.state.updateSite) {
      this.props.dispatch(updateSiteAction(siteInfo, data));
    } else {
      data['name'] = siteInfo;
      this.props.dispatch(addSiteAction(data));
    }
  }

  onSiteNameChange(value) {
    this.setState({
      siteName: value
    })
  }

  closeOverlay() {
    this.setState({
      showModalOverlay: false,
      siteName: ''
    })
  }

  markerClick(siteInfo, event) {
    let sitename_enc = encodeURIComponent(siteInfo.name);
    this.props.dispatch(clearTwigsList());
    history.push({
      pathname: constants.ROUTES.SITEVIEW,
      // search: '?name=' + sitename_enc,
      state: siteInfo
    })

  }
  onChange(address) {
    this.setState({
      address: address
    })
  }
  placesHandleSelect(address) {
    this.setState({
      address: address
    });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        // console.log('Success Yay', { lat, lng })
        this.setState({
          center: {
            lat: lat, lng: lng
          },
          zoom: 20
        })
      })
      .catch((error) => {
        // console.log('Error:', error)

      })
  }

  onContextMenu(event){
    // console.log('on context menu')
    event.stopPropagation();
    event.preventDefault();
    return false;
  }
  render() {

    let zoom = 11;
    let containerStyle = {
      height: '100%',
      overflow: 'hidden'
    };
    let contextMenuStyle = {
      display: this.state.showContextMenu ? 'block' : 'none',
      top: this.state.contextMenTopPos,
      left: this.state.contextMenuLeftPos
    }
    if (this.state.center) {

      let markersComponents = this.props.sites.map((item, index) => {
        if (item && item.location) {
          return <MarkerComponent key={index} lat={item.location.latitude}
            lng={item.location.longitude} markerClick={this.markerClick} siteInfo={item} />
        } else {
          return null;
        }

      });
      // console.log('-map-key-', window.googleMapKey)
      const inputProps = {
        type: "text",
        placeholder: "🔍 Enter address",
        value: this.state.address,
        onChange: this.onChange,
      }
      const AutocompleteItem = ({ suggestion }) => (<div><i className="fa fa-map-marker" />{suggestion}</div>)

      return (
        <div style={containerStyle} className='dashboard-map'>
          <div className='header'>
            <span className="dashboard-info show">
              <div>Enter address below to find location on map. Then right click on map to Add or Update Site location.</div>
            </span>
            <PlacesAutocomplete
              inputProps={inputProps}
              onSelect={this.placesHandleSelect}
              onEnterKeyDown={this.placesHandleSelect}
              autocompleteItem={AutocompleteItem}
            />
          </div>
          <div className='map-content' onContextMenu={this.onContextMenu.bind(this)} >
            <span style={contextMenuStyle} className='context-menu-style'>
              <button className='first-btn' onClick={this.addSite}>Add Site</button>
              <button onClick={this.updateSite}>Update Site</button>
            </span>
            < GoogleMapReact
              defaultCenter={this.state.center}
              center={this.state.center}
              defaultZoom={12}
              zoom={this.state.zoom}
              onClick={this.mapClick}
              options={
                {
                  rotateControl: false,
                  zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_CENTER
                  }
                }
              }
              onGoogleApiLoaded={this.mapLoaded}
              yesIWantToUseGoogleMapApiInternals
              ref="googleMap"
              bootstrapURLKeys={{
                key: window.googleMapKey,
              }}

            >
              <CenterMarkerComponent lat={this.state.center.lat}
                lng={this.state.center.lng} />

              {markersComponents}


            </GoogleMapReact >
          </div>

          <MapOverlay show={this.state.showModalOverlay} isUpdate={this.state.updateSite} lat={this.state.markerLat} lng={this.state.markerLong} sites={this.props.sites} closeOverlay={this.closeOverlay} updateSiteLocation={this.updateSiteLocation} onSiteNameChange={this.onSiteNameChange} value={this.state.siteName} />

        </div>
      );
    } else {
      return null;
    }

  }

}

Dashboard.propTypes = {
  dashboard: PropTypes.object,
  search: PropTypes.object
};

let select = (state, props) => ({
  sites: state.dashboard.sites,
  userProfile: state.user.profile
});

class MarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let divStyle = {
      position : 'absolute',
      top : 0,
      'text-align' : 'left',
      width : '150px',
      'font-size' : '18px',
      'text-shadow' : '2px 2px 10px',
      color : 'teal'
    }
    return (
      <span className="marker-translate" >
        <img onClick={this.props.markerClick.bind(this, this.props.siteInfo)} src="/img/marker.png" title={this.props.siteInfo.name} alt={this.props.siteInfo.name} />
        <div style={divStyle}>{this.props.siteInfo.name}</div>

      </span>
    );
  }
}


class CenterMarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {

    return (
      <span className="marker-translate" ><img src="/img/center_marker.png" /></span>
    );
  }
}

export default connect(select)(Dashboard);



// WEBPACK FOOTER //
// ./src/js/components/dashboard/Map.js